import { CreateNewObservationsCategoryForm } from "src/features/Admin/ObservationsCategories/components/CreateNewObservationsCategoryForm";
import { Dialog, DialogContent } from "src/components/ui/dialog";
import { useSearchParams } from "react-router-dom";
import { useObservationCategory } from "src/features/Admin/ObservationsCategories/hooks/useObservationCategory";

type CreateNewCategoryModalProps = {
	test?: string;
	isOpen: boolean;
	onClose: () => void;
};

const CreateNewCategoryModal = ({
	onClose,
	isOpen
}: CreateNewCategoryModalProps) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const categoryId =
		parseInt(searchParams.get("categoryId") || "") || undefined;

	const { data: category, isInitialLoading: isLoadingCategory } =
		useObservationCategory(categoryId, {
			enabled: Boolean(categoryId)
		});

	const handleClose = () => {
		onClose?.();
		setSearchParams({});
	};

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
			<DialogContent className="mt-[200px] p-6 w-[80%] max-w-[979px] rounded-xl">
				<h1 className="font-heading text-lg font-medium text-foreground mb-4">
					{categoryId ? "Edit category" : "Create new category"}
				</h1>

				<CreateNewObservationsCategoryForm
					defaultValues={{ name: category?.name || "" }}
					categoryId={categoryId}
					onClose={handleClose}
					isLoading={isLoadingCategory}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default CreateNewCategoryModal;
